/**
 * Araç listesinden araç ID bazlı envanter haritası oluşturur
 * @param {Array} vehicles - Araç listesi (tracking.getAll'dan gelen)
 * @returns {Object} vehicleId: inventory[] şeklinde map
 */
function getVehicleInventoryMap(vehicles) {
  const inventoryMap = {};

  if (!vehicles || !Array.isArray(vehicles)) {
    return inventoryMap;
  }

  vehicles.forEach(vehicle => {
    if (vehicle.id && vehicle.inventory) {
      // Envanter bilgisini araç ID'sine göre mapla
      inventoryMap[vehicle.id] = vehicle.inventory.map(item => ({
        inventory_id: item.inventory_id,
        product_code: item.product_code,
        name: item.name,
        category: item.category,
        quantity: item.quantity || 1,
        unit: item.unit || 'ADET',
        status: item.status
      }));
    }
  });

  return inventoryMap;
}

module.exports = {
  getVehicleInventoryMap
};